import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from './../../../../themes/default';

const styles = theme => ({
  root:        { zIndex: 2, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',  },
  primary:     { backgroundColor: theme.palette.grey[100] },
  secondary:   { backgroundColor: 'rgba(255,255,255,.9)' }
});

const Loading = ({ classes, variant, ...rest}) => {

  return (
    <div className={ classNames( classes.root, classes[variant] ) }>
      <CircularProgress />
    </div>
  )

}

Loading.propTypes = {
  variant:  PropTypes.string
};

export default withStyles(styles)(Loading);
